import * as yup from 'yup';

export const LoginSchema = yup
    .object({
        email: yup
            .string()
            .required('Field is required')
            .email('Must be a valid email')
            .min(5, 'Must have more than 5 characters')
            .max(256, 'Must have less than 256 characters'),
        password: yup
            .string()
            .required('Field is required')
            .min(8, 'Password must be at least 8 characters')
            .max(256, 'Must have less than 256 characters'),
    })
    .required();
